import { render, staticRenderFns } from "./divisionalManage.vue?vue&type=template&id=1708ed1c&scoped=true&"
import script from "./divisionalManage.vue?vue&type=script&lang=js&"
export * from "./divisionalManage.vue?vue&type=script&lang=js&"
import style0 from "./divisionalManage.vue?vue&type=style&index=0&id=1708ed1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708ed1c",
  null
  
)

export default component.exports